/*  
  Developers: Sakshi Bhise  
  File: index.tsx  
  Date: 06/18/2025  
  Project Name: AskHR  
  Team: DSET  
  
  Purpose:  
  Entry point for the AskHR React application.  
  Mounts the root App component, initializes theme and Fluent UI icons,  
  provides application-wide state/context, configures i18n (internationalization),  
  routing, layout and accessibility adjustments, and language-aware theming.  
*/

import ReactDOM from 'react-dom/client';
import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import './index.css';
import { msalConfig } from './state/msalConfig';
import App from './App'; // App component  
// Initialize Fluent UI icons  
import { initializeIcons } from '@fluentui/react';
import AuthGate from './state/AuthGate';
import { AppStateProvider } from './state/AppProvider';

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/');

// Initialize MSAL instance  
const msalInstance = new PublicClientApplication(msalConfig);

// Function to initialize MSAL and mount the app  
async function initializeAndRenderApp() {
  // Initialize the MSAL instance before rendering
  await msalInstance.initialize();

  const rootElement = document.getElementById('root');

  if (!rootElement) {
    console.error('Failed to find root element');
    return;
  }
  const root = ReactDOM.createRoot(rootElement);


  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
          <App />
      </MsalProvider>
    </React.StrictMode>
  );
}

// Call the function to initialize MSAL and render the app  
initializeAndRenderApp();  